import { restApi } from "@/api/index";

/**
 * Joins a community
 * @param {{ invite_code: string }} data - Community join data
 * @returns {Promise} Promise representing the API response
 */
export const joinCommunity = (data) => {
  return restApi.post("user/communities/join", data);
};

/**
 * Leaves a specific community
 * @param {string|number} communityId - The ID of the community to leave
 * @returns {Promise} Promise representing the API response
 */
export const leaveCommunity = (communityId) => {
  return restApi.post(`user/communities/${communityId}/leave`, {});
};

/**
 * Updates community-specific settings for the user
 * @param {string|number} communityId - The ID of the community to update
 * @param {{ is_active: boolean }} data - The community settings data to update
 * @returns {Promise} Promise representing the API response
 */
export const updateCommunity = (communityId, data) => {
  return restApi.post(`user/communities/${communityId}/update`, data);
};
